import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  connect() {
    this.submitParams = JSON.parse(this.element.dataset.submitParams) || {};
    this.initializeDropzoneCallbacks()
  }

  initializeDropzoneCallbacks() {
    this.element.querySelectorAll(".dropzone-wrapper").forEach(dropzoneWrapper => {
      dropzoneWrapper.addEventListener("dropzone:upload:success", (e) => {
        this.submitDocument({element: dropzoneWrapper, fieldName: e.detail.fieldName, filePath: e.detail.filePath, preview: e.detail.uploadedFilePreview});      
      })
      dropzoneWrapper.addEventListener("dropzone:upload:processing", () => {
        this.documentProcessing({element: dropzoneWrapper});
      })
      dropzoneWrapper.addEventListener("dropzone:upload:error", (e) => {
        this.documentError({element: dropzoneWrapper, error: e.detail.error});
      })
    })
  }

  submitDocument({element, filePath}) {
    element.style.opacity = 1;
    element.style.pointerEvents = "auto";
    const urlInput = document.getElementById(this.submitParams.submit_input_id)
    urlInput.value = filePath
    this.submitButtonTarget.disabled = false;
  }

  documentProcessing({element}) {
    element.style.opacity = 0.5
    element.style.pointerEvents = "none"
  }

  documentError({element, error}) {
    element.style.opacity = 1;
    element.style.pointerEvents = "auto";
    // Note: Dropzone already handles upload error display
  }
}